<div class="sub-contract-modal">

  <!-- Header -->
  <div class="header">
    <div class="header-left">
      <ng-icon name="tablerShare" class="header-icon"></ng-icon>
      <div>
        <h4>{{ isEditMode ? 'Edit Sub-Contract' : 'Sub-Contract Job' }}</h4>
        <p class="header-sub" *ngIf="jobDetails?.jobTitle">{{ jobDetails.jobTitle }}</p>
      </div>
    </div>
    <button class="btn btn-sm btn-light close-btn" (click)="cancel()">
      <ng-icon name="tablerX"></ng-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="content">

    <div *ngIf="loading" class="loading-state">
      <ng-icon name="tablerLoader2" class="spin"></ng-icon> Loading networks...
    </div>

    <ng-container *ngIf="!loading">

      <!-- Client rate info banner -->
      <div class="client-rate-banner" *ngIf="hasClientRate">
        <ng-icon name="tablerInfoCircle"></ng-icon>
        Client rate: <strong>{{ currencySymbol }}{{ jobDetails.targetRateFrom }} – {{ currencySymbol }}{{ jobDetails.targetRateTo }}</strong> / {{ jobDetails.payType | lowercase }}
      </div>

      <!-- Networks -->
      <div class="form-group">
        <label class="form-label">Share to Networks</label>
        <ng-select class="multiselectlable" [class.is-invalid]="submitted && !selectedNetworks.length"
          [items]="networks"
          bindLabel="name"
          placeholder="Select networks..."
          [multiple]="true"
          [closeOnSelect]="false"
          [clearable]="false"
          appendTo="body"
          [(ngModel)]="selectedNetworks">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <ng-container *ngIf="item.type">
              <ng-container *ngIf="index === 0 || networks[index - 1]?.type !== item.type">
                <div class="networktype">{{ item.type }}</div>
              </ng-container>
              <div class="ng-select-checkbox-label" [class.permission-disabled]="item.disabled">
                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;" *ngIf="item.disabled"></ng-icon>
                <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
              </div>
            </ng-container>
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <div class="selected-item">
              <span class="ng-value-clear remove-icon" (click)="clear(item)" *ngIf="!isLocked(item) && !item.disabled">✕</span>
              <ng-icon name="tablerLock" style="font-size:10px;margin-right:4px;color:#8B5CF6;" *ngIf="isLocked(item) && !item.disabled"></ng-icon>
              <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;" *ngIf="item.disabled"></ng-icon>
              <span class="ng-value-label">{{ item.name }}</span>
            </div>
          </ng-template>
        </ng-select>
        <div class="field-error" *ngIf="submitted && !selectedNetworks.length">Please select at least one network</div>
      </div>

      <!-- Rate row -->
      <div class="rate-row">
        <div class="rate-field">
          <label class="form-label">Rate From ({{ currencySymbol }})</label>
          <input type="number" class="form-control" placeholder="e.g. 80" min="1" [(ngModel)]="rateFrom">
          <div class="field-error" *ngIf="submitted && (!rateFrom || rateFrom <= 0)">Rate From is required</div>
        </div>
        <div class="rate-field">
          <label class="form-label">Rate To ({{ currencySymbol }})</label>
          <input type="number" class="form-control" placeholder="e.g. 100" min="1" [(ngModel)]="rateTo">
          <div class="field-error" *ngIf="submitted && (!rateTo || rateTo <= 0)">Rate To is required</div>
        </div>
        <div class="rate-type-field">
          <label class="form-label">Rate Type</label>
          <ng-select
            [items]="rateTypes"
            bindLabel="label"
            bindValue="value"
            placeholder="Select"
            [clearable]="false"
            [searchable]="false"
            appendTo="body"
            [class.is-invalid]="submitted && !rateType"
            [(ngModel)]="rateType">
          </ng-select>
          <div class="field-error" *ngIf="submitted && !rateType">Rate Type is required</div>
        </div>
      </div>

    </ng-container>

  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="submitting || loading"
      (click)="submit()">
      <ng-icon name="tablerLoader2" class="spin" *ngIf="submitting"></ng-icon>
      {{ isEditMode ? 'Update' : 'Sub-Contract' }}
    </button>
  </div>

</div>
